if (!customElements.get('product-spec-table')) {
  class ProductSpecTable extends HTMLElement {
    constructor() {
      super();
      this.onToggle = this.onToggle.bind(this);
    }

    connectedCallback() {
      this.toggle = this.querySelector('[data-spec-toggle]');
      if (this.toggle) {
        this.toggle.addEventListener('click', this.onToggle);
      }
    }

    disconnectedCallback() {
      if (this.toggle) {
        this.toggle.removeEventListener('click', this.onToggle);
      }
    }

    onToggle() {
      const expanded = this.dataset.expanded === 'true';
      const next = (!expanded).toString();

      this.dataset.expanded = next;
      this.toggle.setAttribute('aria-expanded', next);

      const label = this.toggle.querySelector('[data-toggle-label]');
      if (label) {
        label.textContent = expanded ? this.dataset.textShowAll : this.dataset.textShowFewer;
      }
    }
  }

  customElements.define('product-spec-table', ProductSpecTable);
}
